import {h,Component, Fragment} from "preact";
import {route} from "preact-router";
import PFeed from "../../../services/prematch-feed";
import Ticket from "../utils/ticket-logic.jsx";
import SchedulesTimeFilter from "../utils/schedules-time-filter.jsx";

import PrematchEventPreview from "../mobile-components/prematch-event-preview.jsx";

import * as P from "../mobile-templates/tournament.jsx";
import * as I from "../utils/icons.jsx";

import FullSite from "./full-site";


export default function PrematchTournament(props) {
	return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit"><PrematchTournamentPage {...props} /></FullSite>
}

export class PrematchTournamentPage extends Component {
	state = {
		tournamentCard: null
	}
	
	componentWillMount() {
		PFeed.getMenu((label, menu) => {
			this.setState({})
			const {sportId, categoryId, tournamentId} = this.props;
			PFeed.callTournamentMono('/tournament/'+sportId+'/'+categoryId+'/'+tournamentId, {}, (label, tournamentCard) => {
				this.setState({
					tournamentCard: tournamentCard
				})
			})
		})
	}
	
	render({sportId, categoryId, tournamentId}) {
		if (!PFeed.menu)
			return null;
		
		const sport = PFeed.menu['/sport/'+sportId];
		const category = sport.sub['/category/'+sportId+'/'+categoryId];
		const tournament = category.sub['/tournament/'+sportId+'/'+categoryId+'/'+tournamentId];
		return <Fragment>
			<P.TournamentHeader sport={sport} category={category} onClose={() => route("/prematch/"+sport.id.split('/').slice(2).join('/'))} />
			<P.TournamentInfo tournament={tournament} />
			{this.state.tournamentCard && <TournamentCard 
											  sport={sport} 
											  category={category} 
											  tournament={tournament} 
											  tournamentCard={this.state.tournamentCard} 
											/>}
			<P.FakeSeparator />
		</Fragment>;
	}
}

export class TournamentCard extends Component {
	static useExtendedMatchRow = false;
	
	state = {
		giornateSorted: [],
		displayRuleFiltered: null
	};
	componentWillMount() {
		const giornateSorted = this.groupEventsByDay(this.props.tournamentCard.sub)
		const displayRuleFiltered = this.displayRuleOnlyOneMarket(this.props.tournamentCard.displayRule)
		this.setState({
			giornateSorted: giornateSorted,
			displayRuleFiltered: displayRuleFiltered.length > 3 ? [] : displayRuleFiltered
		})
	}
	groupEventsByDay(events) {
		const giornateMap = Object.values(events).sort((a, b) => a.date - b.date).reduce((days, event) => {
			const day = this.getLocalEventDate(event);
			days[day] = days[day] || [];
			days[day].push(event);
			return days;
		}, {})
		const giornateSorted = Object.values(giornateMap).sort((a, b) => a[0].date - b[0].date);
		return giornateSorted;
	}
	displayRuleOnlyOneMarket(displayRule) {
		const firstMarket = this.props.tournamentCard.displayRule[0].id.split('.')[0];
		const displayRuleFiltered = this.props.tournamentCard.displayRule.filter(outcome => outcome.id.split('.')[0] == firstMarket);
		return displayRuleFiltered;
	}
	getLocalEventDate(event) {
		return new Date(event.date * 1000).toLocaleDateString(undefined, {year: "2-digit", month:"short", day: "numeric"});
	}
	render({sport, category, tournament, tournamentCard}) {
		const {giornateSorted, displayRuleFiltered} = this.state;
		return giornateSorted.filter(s => SchedulesTimeFilter.isEventAllowed(s[0])).map(eventsList => <Fragment>
			<P.TournamentDatesHeader>
				<P.TournamentDate>{this.getLocalEventDate(eventsList[0])}</P.TournamentDate>
				{!TournamentCard.useExtendedMatchRow && displayRuleFiltered.map(outcome => <P.OutcomeNameHeader>{outcome.name}</P.OutcomeNameHeader>)}
			</P.TournamentDatesHeader>
			{eventsList.filter(s => SchedulesTimeFilter.isEventAllowed(s)).map(event => <EventComponent {...{tournament, event, displayRuleFiltered, tournamentCard}} />)}
		</Fragment>)
	}
}

export class MobileEvent extends Component {
	getLocalEventTime(event) {
		return new Date(event.date * 1000).toLocaleTimeString();
	}
	render({tournament, event, displayRuleFiltered}) {
		return <P.MatchRow>
			<P.MatchInfo onClick={() => route("/prematch/"+tournament.id.split('/').slice(2).join('/')+'/'+event.id.split('/').slice(2).join('/'))}>
				<P.Teams>
					<P.HomeTeamName>{event.home}</P.HomeTeamName>
					<P.AwayTeamName>{event.away}</P.AwayTeamName>
				</P.Teams>
				<P.MatchTime>{this.getLocalEventTime(event)}</P.MatchTime>
			</P.MatchInfo>
			<P.StatsCell><I.StatsIcon class="w-4" /></P.StatsCell>
			{displayRuleFiltered.map(outcome => {
				const [marketCode, outcomeCode] = outcome.id.split('.');
				const market = event.sub['/market/'+event.id.split('/').slice(-1)[0]+'/'+marketCode] || {sub:{}}
				const odd = market.sub[market.id.replace('market', 'odd')+'/'+outcomeCode] || {value: 0, active: false};
				return <P.OddButtonCell>
					<P.OddButton 
						value={odd.value} 
						active={odd.active} 
						onClick={() => Ticket.togglePrematchOdds(odd.id)} 
						selected={Ticket.hasPrematchOdds(odd.id)} />
				</P.OddButtonCell>;
			})}
			<P.StarCell><I.FavouritesIcon class="h-6" /></P.StarCell>
		</P.MatchRow>;
	}
}

const EventComponent = TournamentCard.useExtendedMatchRow ? PrematchEventPreview : MobileEvent;